import React, { FC } from 'react';

import { Redirect } from '@reach/router';

import { AnimatedRoute as Scene, AnimatedRouter as Router } from '../../components/AnimatedRouter';
import ClubWizard from '../../scenes/admin/ClubWizard';
import Register from '../../scenes/player/Register';
import AdminRoutes from '../Utils/Routes/admin.routes';
import ClubWizardRoutes from '../Utils/Routes/clubwizard.routes';
import CommonRoutes from '../Utils/Routes/common.routes';
import PlayerRoutes from '../Utils/Routes/player.routes';
import RegisterRoutes from '../Utils/Routes/register.routes';
import { generateRoutes } from '../Utils/generateRoutes';
import SomethingWentWrong from '../../scenes/common/SomethingWentWrong';

interface IProps {
  actionSelector: any;
}

const ContentRouter: FC<IProps> = props => {
  const { actionSelector } = props;

  return (
    <Router>
      <Scene path="/error" component={SomethingWentWrong} />

      {/* COMMON ROUTES */}
      {generateRoutes(CommonRoutes)}

      {/* PLAYER ROUTES */}
      {generateRoutes(PlayerRoutes, actionSelector)}

      {/* REGISTER ROUTES */}
      <Scene path="register" component={Register}>
        {generateRoutes(RegisterRoutes, actionSelector)}
      </Scene>

      {/* ADMIN ROUTES */}
      {generateRoutes(AdminRoutes, actionSelector)}

      <Scene path="/staff/club/create" component={ClubWizard}>
        {generateRoutes(ClubWizardRoutes, actionSelector)}
      </Scene>

      <Redirect
        from="staff/club/:clubId/event/:eventId"
        to="staff/club/:clubId/event/:eventId/setup/start"
        noThrow={true}
      />

      <Redirect
        from="staff/club/:clubId/event/:eventId/round/:roundId"
        to="staff/club/:clubId/event/:eventId/round/:roundId/setup"
        noThrow={true}
      />

      <Redirect from="staff/club/create" to="staff/club/create/account" noThrow={true} />
    </Router>
  );
};

export default ContentRouter;
